import MinimumVersionSection from './minimumVersion/section/MinimumVersionSection';
import SpecificVersions from './specificVersions/section/SpecificVersionsSection';

const ChooseMain = ({ selectedType }) => {
  //if (selectedType === 3) return null;
  if (selectedType === 1) return <MinimumVersionSection />;
  if (selectedType === 2) return <SpecificVersions />;
};

export default ChooseMain;
